import { useQuery } from "@tanstack/react-query";
import { partnerMarketingApi } from "libs/api";
import { useParams } from "router";
import { PartnerMarketingQueryKey } from "./constants/partnerMarketingQueryKeyEnum";
import { usePartnerMarketingModelState } from "./partnerMarketingModelAtom";

export const usePartnerMarketingApi = () => {
    const { lang } = useParams("/:lang/list-my-property");
    const [value, setValue] = usePartnerMarketingModelState();

    const { isLoading } = useQuery({
        queryKey: [PartnerMarketingQueryKey.GetPartnerMarketingModel, lang],
        queryFn: () => partnerMarketingApi.getPartnerMarketingModel(lang).then((res) => res.data),
        onSuccess: setValue,
    });

    return {
        isLoading: isLoading || value === undefined,
    };
};
